(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fragrance-tab"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.pf-tab');
  const contents = document.querySelectorAll('.pf-content-card');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabId = tab.getAttribute('data-tab');
      
      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('pf-active'));
      contents.forEach(c => c.classList.remove('pf-active'));

      // Add active class to clicked tab and corresponding content
      tab.classList.add('pf-active');
      document.getElementById(tabId).classList.add('pf-active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
